export default __webpack_public_path__ + "static/media/recorte_24.d2254c08.JPG";